import { getRecaptchaToken } from './recaptcha';

export function initContactForm() {
  const forms = document.querySelectorAll('.contact-form');
  if (!forms.length) return;
  forms.forEach((form) => {
    const status = form.querySelector('.message-status');
    const loader = form.querySelector('.form-btn-loader');
    const button = form.querySelector('button.pbmit-btn');
    const buttonText = button?.querySelector('span');
    const errorMsg = form.dataset.errorMsg || 'An error occurred. Please try again or contact us directly.';

    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      // Validation HTML5
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      // UI: loading
      status.innerHTML = '';
      loader?.classList.remove('d-none');
      buttonText?.classList.add('d-none');
      button?.setAttribute('disabled', 'disabled');

      // reCAPTCHA token
      const token = await getRecaptchaToken('contact');
      const tokenField = form.querySelector('.g-recaptcha-response');
      if (tokenField) tokenField.value = token;

      // Serialize form
      const data = Object.fromEntries(new FormData(form).entries());

      try {
        const response = await fetch(form.action, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-CSRF-TOKEN': document
              .querySelector('meta[name="csrf-token"]')
              ?.getAttribute('content'),
          },
          body: JSON.stringify(data),
        });

        // UI: reset buttons
        loader?.classList.add('d-none');
        buttonText?.classList.remove('d-none');
        button?.removeAttribute('disabled');
        status?.classList.remove('d-none');

        if (response.ok) {
          const json = await response.json();
          status.innerHTML = json.success ?? errorMsg;
        } else if (response.status === 422) {
          // Validation error — try to extract message
          try {
            const json = await response.json();
            const firstError = json.errors ? Object.values(json.errors)[0][0] : json.message;
            status.innerHTML = '<p class="text-danger">' + (firstError || errorMsg) + '</p>';
          } catch (_) {
            status.innerHTML = '<p class="text-danger">' + errorMsg + '</p>';
          }
        } else {
          status.innerHTML = '<p class="text-danger">' + errorMsg + '</p>';
        }
      } catch (err) {
        console.error(err);

        loader?.classList.add('d-none');
        buttonText?.classList.remove('d-none');
        button?.removeAttribute('disabled');

        status?.classList.remove('d-none');
        status.innerHTML = '<p class="text-danger">' + errorMsg + '</p>';
      }
    });
  });
}
